<template>
  <div>
    <botton-bar/>
    <div class="content">
      <loading v-if="load" :fullscrean="true" text="Por favor aguarde"/>
      <div class="container" v-show="!load">
        <div class="row no-gutters justify-content-between align-items-center">
          <div class="col-md-6 text-center text-md-left">
            <h4 class="mb-0">Listas de Batismo</h4>
          </div>
          <div class="col-md-4 mt-3 mt-md-0">
            <select class="form-control" v-model="pesquisa.ano" @change="getListas()">
              <option :value="2026">2026</option>
              <option :value="2025">2025</option>
              <option :value="2024">2024</option>
            </select>
          </div>
        </div>
        <hr>
        <c-offline v-if="offline"/>
        <div class="mb-3" v-for="l in listas">
          <lista :nome="`${meses.find(m => m.valor == l.mes_lista).mes} de ${l.ano_lista}`" @go="abrirLista(l.id_lista)" icone="true">
            <div class="text-muted">
              {{ l.nome_lista }}
            </div>
          </lista>
        </div>
      </div>
    </div>

    <lista-preview :meses="meses"/>
  </div>
</template>

<script>
  import BottonBar from "../components/BottonBar";
  import Lista from "../components/Lista";
  import Loading from "@/components/Loading";
  import ListaPreview from "@/components/listas/ListaPreview";
  import COffline from "@/components/COffline";
  export default {
    name: 'Home',
    components: {COffline, ListaPreview, Loading, Lista, BottonBar},
    data() {
      return {
        anoAtual: new Date().getFullYear(),
        load: false,
        offline: false,
        pesquisa: { ano: '' },
        listaKey: ''
      }
    },

    methods: {
      getListas() {
        const cacheKey = this.isLogged && this.user.id_cidade ? `cidade-${this.user.id_cidade}` : 'public';

        if (this.listas.length && this.listas[0].ano_lista === this.pesquisa.ano && this.listaKey === cacheKey) {
          return;
        }

        this.load = true;
        this.dados = null;
        const url = 'app/listas/' + this.regionalId;
        const params = { ...this.pesquisa, app: 1 };
        const cache = url + `/${this.pesquisa.ano}/app/${cacheKey}`;

        if (this.isLogged && this.user.token) {
          params.token = this.user.token;
        }

        this.$http.get(url, { params })
          .then(response => {
            const listas = response.data || []
            this.$store.commit('setListas', listas);
            localStorage.setItem(cache, JSON.stringify(listas));
            this.listaKey = cacheKey;
            this.load = false;

          }, res => {
            const listas = localStorage.getItem(cache);

            if (listas) {
              this.offline = false;
              this.$store.commit('setListas', JSON.parse(listas));
              this.listaKey = cacheKey;

            } else {
              this.$store.commit('setListas', []);
              this.offline = true;
            }

            this.load = false;
          });
      },

      abrirLista(id_lista) {
        this.$router.push('/listas/' + id_lista + '?regional=' + this.regionalId);
      }
    },

    mounted() {
      document.body.classList.remove("modal-open");
      this.pesquisa.ano = this.anoAtual;
      const id = this.$route.params.id;

      if (id && !isNaN(parseInt(id))) {
        this.$emit('openModal', id);

      } else {
        this.getListas();
      }
    },

    computed: {
      user() {
        return this.$store.state.user;
      },

      isLogged() {
        return !!this.user.id_membro;
      },

      regionalId() {
        return this.$store.state.id_regional;
      },

      meses() {
        return this.$store.state.meses;
      },

      listas() {
        return this.$store.state.listas;
      }
    },

    watch: {
      $route(to, from) {
        if (to.name === 'Lista' && to.params.id) {
          this.$emit('openModal', to.params.id);

        } else {
          this.$emit('closeModal');
          this.getListas();
        }
      },

      isLogged() {
        this.getListas();
      },

      'user.id_cidade'(val, old) {
        if (val !== old) {
          this.getListas();
        }
      }
    }
  }
</script>
<style scoped>
</style>
